import { RouteFragment } from "@impero-com/common/routeFragments";

const WebRoute = {
    ROOT: "/",
    OAUTH_AUTHORIZE: "/oauth/authorize",
    REGISTER: "/register",
    RESET_PASSWORD: "/reset-password",
    EVENT_LOG: `/events`,
    PROFILE: `/profile`,
    FINANCIAL_YEAR: `/financial-year`,
    USERS: `/${RouteFragment.USERS}`,
    USER_GROUPS: `/${RouteFragment.USER_GROUPS}`,
    CONTROLS: `/${RouteFragment.CONTROLS}`,
    CONTROLS_BULKASSIGN: `/${RouteFragment.CONTROLS}/bulk-assign`,
    CONTROLS_BULKIMPORT: `/${RouteFragment.CONTROLS}/bulk-import`,
    CONTROLS_NEW: `/${RouteFragment.CONTROLS}/new`,
    CONTROLS_ALL: `/${RouteFragment.CONTROLS}/all`,
    CONTROLS_WEEKLY: `/${RouteFragment.CONTROLS}/weekly`,
    CONTROLS_MONTHLY: `/${RouteFragment.CONTROLS}/monthly`,
    CONTROLS_TWO_MONTHS: `/${RouteFragment.CONTROLS}/two-months`,
    CONTROLS_QUARTERLY: `/${RouteFragment.CONTROLS}/quarterly`,
    CONTROLS_HALF_YEARLY: `/${RouteFragment.CONTROLS}/half-yearly`,
    CONTROLS_YEARLY: `/${RouteFragment.CONTROLS}/yearly`,
    CONTROLS_MANUAL: `/${RouteFragment.CONTROLS}/manual`,
    TESTING_PROGRAMS: `/${RouteFragment.TESTING_PROGRAMS}`,
    TESTING_PROGRAMS_NEW: `/${RouteFragment.TESTING_PROGRAMS}/new`,
    TESTING_CONTROLS: `/${RouteFragment.TESTING_CONTROLS}`,
    TESTING_CONTROLS_NEW: `/${RouteFragment.TESTING_CONTROLS}/new`,
    TESTING_ACTIVITIES: `/${RouteFragment.TESTING_ACTIVITIES}`,
    TESTING_ACTIVITIES_PENDING: `/${RouteFragment.TESTING_ACTIVITIES}/pending`,
    REPORTS: `/${RouteFragment.REPORTS}`,
    REPORTS_STATUS: `/${RouteFragment.REPORTS}/status`,
    REPORTS_WORKLOAD: `/${RouteFragment.REPORTS}/workload`,
    REPORTS_CLASSIFICATION: `/${RouteFragment.REPORTS}/classification`,
    REPORTS_CLASSIFICATION_CLASSIFICATIONS: `/${RouteFragment.REPORTS}/classification/classifications`,
    REPORTS_CLASSIFICATION_ACCESS_RIGHTS: `/${RouteFragment.REPORTS}/classification/:classificationId/access-rights`,
    REPORTS_DATASHEET: `/${RouteFragment.REPORTS}/datasheet`,
    REPORTS_ACCESS_RIGHTS: `/${RouteFragment.REPORTS}/:savedReportId/access-rights`,
    SETUP_2FA: `/setup-2fa`,
    TAGS: `/${RouteFragment.TAGS}`,
    TAGS_CONTROL_PROGRAM: `/${RouteFragment.TAGS}/${RouteFragment.CONTROL_PROGRAM}`,
    RISKS: `/risks`,
    HOME: "/home",
    DASHBOARD_V2: `/dashboard-overview`,
    DASHBOARD_PENDING_ACTIVITIES: "/dashboard-pending-activities",
    WONDERLAND: "/wonderland",
    RISK_ENTITIES: `/${RouteFragment.RISK_ENTITIES}`,
    ENTITIES: `/${RouteFragment.ENTITIES}`,
    ENTITIES_NEW: `/${RouteFragment.ENTITIES}/new`,
    CONTROL_PROGRAMS: `/${RouteFragment.CONTROL_PROGRAMS}`,
    CONTROL_PROGRAMS_NEW: `/${RouteFragment.CONTROL_PROGRAMS}/new`,
    CONTROL_ACTIVITIES: `/${RouteFragment.CONTROL_ACTIVITIES}`,
    DASHBOARD: `/dashboard`,
    CONTROL_HEALTH: `/control-health`,
    CONTROL_POLICIES: "/control-policies",
} as const;

export { WebRoute };
